import { Plan } from '@/domain/models/plan-license/plan-model'
import { Account } from '@/domain/usecases'

export const getAvailablePlans = (
  showFullCatalog: boolean,
  account: Account.Model
): Plan.Enum[] => {
  const allPlans = Plan.getAll()
  const userPlanId = Number(account.passPlan?.id)

  return showFullCatalog ? allPlans : allPlans.filter(planItem => planItem.id >= userPlanId)
}
